export default function makeMap(list) {
	const map = {};
	for (let i = 0; i < list.length; i++) {
		map[list[i].id] = list[i];
	}
	return map;
}